import { Component, OnInit, ViewChild, ElementRef, Renderer2, Pipe, Inject } from '@angular/core';
//import { Http, ResponseContentType } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { NgbModule, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { saveAs } from 'file-saver';
import { AgGridModule, AgGridNg2 } from 'ag-grid-angular';
// import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

// import { FormGroup, FormControl } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { JobPlant } from '../../model/JobPlant';
import { PlantMasterService } from '../../services/plantMaster.service'

import {
  NgbDateStruct, NgbCalendar,
  NgbDatepicker,
  NgbInputDatepicker,
  NgbDateAdapter,
  NgbDateParserFormatter
} from '@ng-bootstrap/ng-bootstrap';
import { NgModel } from "@angular/forms";
import { Subscription } from 'rxjs';
import * as JSZip from 'jszip';

const now = new Date();

const equals = (one: NgbDateStruct, two: NgbDateStruct) =>
  one && two && two.year === one.year && two.month === one.month && two.day === one.day;

const before = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
    ? false : one.day < two.day : one.month < two.month : one.year < two.year;

const after = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
    ? false : one.day > two.day : one.month > two.month : one.year > two.year;


@Component({
  selector: 'app-jobPlant, ngbd-datepicker-range, ngbd-datepicker-popup, ngbd-modal-basic',
  templateUrl: './jobPlant.component.html',
  styleUrls: ['./jobPlant.component.css']
})

export class JobPlantComponent implements OnInit {
  jobPlantList: JobPlant[];
  //cpiImage:
  loading = true;
  startDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;
  hoveredDate: NgbDateStruct;
  fromDate: any;
  toDate: any;
  model: any;
  private _subscription: Subscription;
  private _selectSubscription: Subscription;
  @ViewChild("d") input: NgbInputDatepicker;
  @ViewChild(NgModel) datePick: NgModel;
  @ViewChild('myRangeInput') myRangeInput: ElementRef;
  @ViewChild('jobPlantGrid') cpiGrid: AgGridNg2;

  isHovered = date =>
    this.fromDate && !this.toDate && this.hoveredDate && after(date, this.fromDate) && before(date, this.hoveredDate)
  isInside = date => after(date, this.fromDate) && before(date, this.toDate);
  isFrom = date => equals(date, this.fromDate);
  isTo = date => equals(date, this.toDate);

  closeResult: string;


  //Ag-Grid
  gridApi;
  defaultColDef = { editable: true };

  columnDefs = [
    // {
    //   headerName: 'ID', field: 'Id', width: 80,
    //   floatingFilterComponentParams: { suppressFilterButton: true }
    // },
    {
      headerName: 'Job No', field: 'jobNo', width: 80,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'Plant Type', field: 'plantType', width: 150,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'Model', field: 'model', width: 150,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'Serial No', field: 'serialNo', width: 150, //checkboxSelection: true, //editable: true, 
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'Supplier', field: 'supplier', width: 120,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'Capacity / Volume / SWL', field: 'capacityVolumnSWL', width: 150,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'Vehicle Plate', field: 'vehiclePlate', width: 120,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'Owner', field: 'owner', width: 120,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'Location', field: 'location', width: 120,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'Plant No (Owner)', field: 'plantNoOwner', width: 100,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'User Company', field: 'userCompany', width: 120,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'Date In', field: 'fromDate', width: 150,
      valueFormatter: dateFormatter,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'Date Out', field: 'toDate', width: 150,
      valueFormatter: dateFormatter,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'Area Manager', field: 'areaMgr', width: 150,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'Coordinator', field: 'permitCoordinator', width: 150,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'Permit No', field: 'permitNo', width: 100,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'Permit Issue Date', field: 'permitIssueDate', width: 150,
      valueFormatter: dateFormatter,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'Permit Expiry Date', field: 'permitExpiryDate', width: 150,
      valueFormatter: dateFormatter,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'Statutory Certificate No.', field: 'statCertNo', width: 100,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'Statutory Certificate Issue Date', field: 'statCertIssueDate', width: 150,
      valueFormatter: dateFormatter,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'Statutory Certificate ExpiryDate.', field: 'statCertExpiryDate', width: 150,
      valueFormatter: dateFormatter,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'CPI No.', field: 'CPINo', width: 100,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'CPI Issue Date', field: 'CPIIssueDate', width: 150,
      valueFormatter: dateFormatter,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'CPI Expiry Date', field: 'CPIExpiryDate', width: 150,
      valueFormatter: dateFormatter,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'NRMM No.', field: 'nrmmLabelNo', width: 100,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'NRMM Label', field: 'nrmmLabelType', width: 150,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'Remark', field: 'remark', width: 200,
      floatingFilterComponentParams: { suppressFilterButton: true }
    },
    {
      headerName: 'QPME No', field: 'QPMENo', width: 150,
      floatingFilterComponentParams: { suppressFilterButton: true }
    }
  ];

  rowData: any;

  dtOptions: DataTables.Settings = {};


  constructor(private plantMasterService: PlantMasterService,
    calendar: NgbCalendar, element: ElementRef,
    private renderer: Renderer2, private _parserFormatter: NgbDateParserFormatter,
    private modalService: NgbModal,
    private http: HttpClient
    //  private modalService: ModalService
  ) {
    this.fromDate = calendar.getToday();
    this.toDate = calendar.getNext(calendar.getToday(), 'd', 10);
  }

  ngOnInit() {

    this.plantMasterService.getjobPlantList()
      .subscribe(data => {
        this.rowData = data.slice(0);
      });


    this.getjobPlantList();

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10
    };

    this.startDate = { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate() };
    this.maxDate = { year: now.getFullYear() + 1, month: now.getMonth() + 1, day: now.getDate() };
    this.minDate = { year: now.getFullYear() - 1, month: now.getMonth() + 1, day: now.getDate() };

  }

  getjobPlantList(): void {
    this.plantMasterService.getjobPlantList()
      .subscribe(data => this.jobPlantList = data.slice(0));
    //.subscribe(data => this.cpiHeaderList = data.slice(0, 50));
    this.loading = false;
  }

  //#region button: Download CPI/SPI
  // getSelectedRows() {
  //   const selectedNodes = this.cpiGrid.api.getSelectedNodes();
  //   const selectedData = selectedNodes.map(node => node.data);
  //   const selectedDataStringPresentation = selectedData.map(node => node.Id).join(', '); //+ ' ' + node.inspectionDate
  //   this.downloadReport(selectedDataStringPresentation);
  //   //alert(`Selected nodes: ${selectedDataStringPresentation}`);
  // }



  onDateSelection(date: NgbDateStruct) {
    let parsed = '';
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && after(date, this.fromDate)) {
      this.toDate = date;
      // this.model = `${this.fromDate.year} - ${this.toDate.year}`;
      this.input.close();
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
    if (this.fromDate) {
      parsed += this._parserFormatter.format(this.fromDate);
    }
    if (this.toDate) {
      parsed += ' - ' + this._parserFormatter.format(this.toDate);
    }

    this.renderer.setProperty(this.myRangeInput.nativeElement, 'value', parsed);
    ///alert(this._parserFormatter.format(this.fromDate));
    if (this.fromDate && this.toDate) {
      //this.refreshCPIList(this._parserFormatter.format(this.fromDate), this._parserFormatter.format(this.toDate))
    }

  }
}

//Formatter
function dateFormatter(params) {
  console.log('params.value: ' + params.value);
  // console.log(params.value.substring(8, 10));
  // console.log(params.value.substring(5, 7));
  // console.log(params.value.substring(0, 4));

  //var dateInJS = new Date(params.value.substring(0, 4), parseInt(params.value.substring(5, 7)) - 1, params.value.substring(8, 10));

  var year = 1900;
  var month = '01';
  var day = '01';

  if (params.value != null) {
    year = params.value.substring(0, 4);
    month = params.value.substring(5, 7);
    day = params.value.substring(8, 10);
  }


  // console.log(dateInJS);
  // console.log(year);
  // console.log(month);
  // console.log(day);

  return (year + '-' + month + '-' + day);
  //return params.value;

}
